import React from 'react';
import { CalendarMonthProps } from '../../types';
import { nullFn, getLastDayOfMonth, addDaysToCalendar } from '../../utils';
import CalendarWeek from './CalendarWeek';

export default function CalendarMonth({
  value = undefined,
  minValue = undefined,
  maxValue = undefined,
  onChange = nullFn,
  firstOfMonth,
}: CalendarMonthProps): JSX.Element {
  const date = new Date(firstOfMonth);
  const lastOfMonth = getLastDayOfMonth(date);
  const dayOfWeek = date.getDay();
  // const totalWeeks =
  //   (lastOfMonth.getDate() + dayOfWeek + 6 - lastOfMonth.getDay()) / 7;
  const totalWeeks = 6;
  const week = addDaysToCalendar(date, -dayOfWeek);

  const weeks = Array.from(Array(totalWeeks), (item, index) => {
    const startDate = addDaysToCalendar(week, 7 * index);
    const endDate = addDaysToCalendar(startDate, 6);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(11, 59, 59, 999);

    return (
      <CalendarWeek
        value={value}
        startDate={startDate}
        endDate={endDate}
        minValue={minValue}
        maxValue={maxValue}
        firstOfMonth={firstOfMonth}
        lastOfMonth={lastOfMonth}
        key={`${index}_week`}
        onChange={onChange}
      />
    );
  });
  return <tbody>{weeks}</tbody>;
}
